module.exports = __webpack_public_path__ + "static/app-shot-1-5-b0ffd28a885f62002d8b67df5f05abbd.jpg";